module.exports = __webpack_public_path__ + "fonts/955ee494-66b2-4eb2-8f19-bc3a088df16d.bfba1843.ttf";